/**
 * Grill King loading UX — image fade-in, shimmer clear, post-AJAX reinits.
 */
(function () {
  'use strict';

  var IMG_SEL =
    'img.egj-lazy-img, .egj-shop__item img, .fp-card img, .fp-pdp-gallery img, .product__media img, .product-recommendations img, .egj-cart__item-image, .egj-cart img.cart-item__image, .egj-cart__item-slide img';

  function markLoaded(img) {
    if (!img || img.dataset.egjLoaded === '1') return;
    img.dataset.egjLoaded = '1';
    img.classList.add('is-loaded');
    var media = img.closest('.media, .card__media, .product__media, .egj-lazy-media');
    if (media) media.classList.add('is-loaded');
  }

  function bindImage(img) {
    if (!img || img.dataset.egjBound === '1') return;
    img.dataset.egjBound = '1';
    img.classList.add('egj-lazy-img');

    if (img.complete && img.naturalWidth > 0) {
      markLoaded(img);
      return;
    }

    img.addEventListener('load', function onLoad() {
      img.removeEventListener('load', onLoad);
      markLoaded(img);
    });

    img.addEventListener('error', function onError() {
      img.removeEventListener('error', onError);
      markLoaded(img);
    });
  }

  function bindAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(IMG_SEL).forEach(bindImage);
  }

  function setBusy(isBusy) {
    document.documentElement.classList.toggle('egj-is-filtering', !!isBusy);
    document.querySelectorAll('egj-sort-select').forEach(function (el) {
      el.classList.toggle('is-loading', !!isBusy);
      el.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  document.addEventListener('egj:loading', function (event) {
    setBusy(!!(event.detail && event.detail.busy));
  });

  document.addEventListener('facet:updated', function () {
    setBusy(false);
    window.requestAnimationFrame(function () {
      bindAll(document.getElementById('ProductGridContainer') || document);
    });
  });

  document.addEventListener('egj:recommendations-loaded', function (event) {
    var target = event.detail && event.detail.target;
    window.requestAnimationFrame(function () {
      bindAll(target || document);
    });
  });

  document.addEventListener('shopify:section:load', function () {
    bindAll(document);
  });

  if (typeof MutationObserver !== 'undefined') {
    var hosts = [
      document.getElementById('ProductGridContainer'),
      document.getElementById('MainContent'),
      document.querySelector('cart-drawer'),
      document.getElementById('CartDrawer'),
    ].filter(Boolean);

    hosts.forEach(function (host) {
      var mo = new MutationObserver(function () {
        window.clearTimeout(mo._t);
        mo._t = window.setTimeout(function () {
          bindAll(host);
        }, 40);
      });
      mo.observe(host, { childList: true, subtree: true });
    });
  }

  document.addEventListener('cart:updated', function () {
    window.requestAnimationFrame(function () {
      bindAll(document.querySelector('cart-drawer') || document);
    });
  });

  function init() {
    bindAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.EgjLoading = { bindAll: bindAll, setBusy: setBusy };
})();
